import { DoubleSide } from "three";
import { Text } from "@react-three/drei"; // ölçü yazıları için

function parseNum(v, fallback = 0) {
    if (v === null || v === undefined) return fallback;
    const n = parseFloat(String(v).replace(",", "."));
    return isNaN(n) ? fallback : n;
}

export function GlassRoof3D({
    isExporting,
    config,
    isOpenTrigger,
    aluminumColor,
    glassColor,
    glassColor2,
    ...groupProps
}) {
    const sections = (config.sections || []).slice().reverse();
    if (!sections.length) return null;

    // Ölçek — mm → metre
    const SCALE = 0.001;

    // Global değerler (ölçü yazıları için ilk section’dan)
    const firstSection = sections[0];
    const firstSize = firstSection.size;
    const globalHFront = parseNum(firstSize.front_height) * SCALE;
    const globalHBack = parseNum(firstSize.height) * SCALE;

    const frontHeightMm = parseNum(firstSize.front_height, 0);
    const backHeightMm = parseNum(firstSize.height, 0);
    const depthMm = parseNum(firstSize.depth, 0);

    // Profil ölçüleri (metre cinsinden)
    const rafterWidth = 0.05; // 50 mm
    const rafterHeight = 0.05; // 50 mm
    const frameThickness = 0.06; // 60 mm
    const postSize = 0.1; // 100 mm
    const glassThickness = 0.004; // 4 mm
    const glassGap = 0.01; // paneller arası boşluk

    let posX = 0, posZ = 0, angleSum = 0;
    const group = [];

    sections.forEach((section, sIndex) => {

        const size = section.size || {};
        const panelCountX = section.panels ? section.panels.length : 1;
        const panelCountZ = parseNum(size.vertical_glass_count, 1);
        const frontFeetCount = parseNum(size.front_feet_count, 0);
        const backFeetCount = parseNum(size.back_feet_count, 0);

        const w = parseNum(size.width) * SCALE;
        const d = parseNum(size.depth) * SCALE;
        const hFront = parseNum(size.front_height) * SCALE;
        const hBack = parseNum(size.height) * SCALE;

        const panelWidth = w / panelCountX;
        const rows = panelCountZ || 1;
        const panelDepth = d / rows;

        const yAtZ = (z) => hFront + ((hBack - hFront) * z) / d;

        const rafterLength = Math.sqrt(d * d + (hBack - hFront) ** 2) - 0.06;
        const roofTilt = Math.atan2(hBack - hFront, d);

        // Ev ölçüleri (section bazlı)
        const houseDepth = 0.2;
        const houseWidth = w;
        const houseHeight = hBack + 1;
        const houseFrontZ = d - postSize / 2;
        const houseCenterZ = houseFrontZ + houseDepth / 2 + 0.05;

        // Fayans grid (section bazlı)
        const tileCountX = Math.max(1, Math.floor(w / 0.1));
        const tileCountZ = Math.max(1, Math.floor(d / 0.05));
        const tileW = 0.1;
        const tileD = 0.1;

        // Kiriş X pozisyonları
        const rafterPositions = [];
        for (let i = 0; i < panelCountX; i++) {
            rafterPositions.push(-w / 2 + i * panelWidth);
        }

        // Ön dikme X pozisyonları
        const frontFeetPositions = [];
        if (frontFeetCount > 0) {
            const step = w / (frontFeetCount - 1 || 1);
            for (let i = 0; i < frontFeetCount; i++) {
                const x =
                    -w / 2 +
                    step * i +
                    (i === 0 ? 0.02 : 0) -
                    (i === frontFeetCount - 1 ? 0.02 : 0);
                frontFeetPositions.push(x);
            }
        }

        // Arka dikme X pozisyonları
        const backFeetPositions = [];
        if (backFeetCount > 0) {
            const step = w / (backFeetCount - 1 || 1);
            for (let i = 0; i < backFeetCount; i++) {
                const x =
                    -w / 2 +
                    step * i +
                    (i === 0 ? 0.02 : 0) -
                    (i === backFeetCount - 1 ? 0.02 : 0);
                backFeetPositions.push(x);
            }
        }

        const angleRad = (angleSum * Math.PI) / 180;

        // çatıyı ters yöne değil, dış tarafa doğru taşı
const dirX = Math.cos(angleRad);
const dirZ = -Math.sin(angleRad);
const panelOffsetX = posX + dirX * (w / 2);
const panelOffsetZ = posZ + dirZ * (w / 2);


    //   let panelOffsetX = posX;
    //   if (section.angle > 0) {
    //       posZ -= 0.05;
    //       panelOffsetX -= 0.05;
    //   } else {
    //       panelOffsetX += (w / 2);
    //   }

        group.push(
            <group
                key={`section-${sIndex}`}
                position={[panelOffsetX, 0, panelOffsetZ]}
                rotation={[0, angleRad, 0]}
            >
                {/* Kirişler (rafters) */}
                {rafterPositions.map((x, idx) => (
                    <mesh
                        key={`rafter-${sIndex}-${idx}`}
                        position={[x, (hFront + hBack) / 2, d / 2]}
                        rotation={[-roofTilt, 0, 0]}
                    >
                        <boxGeometry args={[rafterWidth, rafterHeight, rafterLength]} />
                        <meshStandardMaterial color={aluminumColor} />
                    </mesh>
                ))}

                {/* Ön kiriş */}
                <mesh position={[0, hFront, 0 + frameThickness / 2]}>
                    <boxGeometry
                        args={[w + 0.06, frameThickness, frameThickness / 2]}
                    />
                    <meshStandardMaterial color={aluminumColor} />
                </mesh>

                {/* Ön Oluk */}
                <mesh position={[0, hFront, 0 - frameThickness + 0.015]}>
                    <boxGeometry
                        args={[w + 0.06, frameThickness, frameThickness / 5]}
                    />
                    <meshStandardMaterial color={aluminumColor} />
                </mesh>
                <mesh position={[0, hFront, 0]}>
                    <boxGeometry args={[w + 0.06, 0.01, frameThickness * 1.5]} />
                    <meshStandardMaterial color={aluminumColor} />
                </mesh>

                {/* Arka kiriş */}
                <mesh position={[0, hBack + 0.02, d - 0.02]}>
                    <boxGeometry
                        args={[w + 0.06, frameThickness + 0.03, frameThickness]}
                    />
                    <meshStandardMaterial color={aluminumColor} />
                </mesh>

                {/* Sol yan kiriş */}
                <mesh
                    position={[-w / 2, (hFront + hBack) / 2, d / 2]}
                    rotation={[-roofTilt, 0, 0]}
                >
                    <boxGeometry
                        args={[frameThickness, frameThickness, rafterLength]}
                    />
                    <meshStandardMaterial color={aluminumColor} />
                </mesh>

                {/* Sağ yan kiriş */}
                <mesh
                    position={[w / 2, (hFront + hBack) / 2, d / 2]}
                    rotation={[-roofTilt, 0, 0]}
                >
                    <boxGeometry
                        args={[frameThickness, frameThickness, rafterLength]}
                    />
                    <meshStandardMaterial color={aluminumColor} />
                </mesh>

                {/* Ara yatay kirişler */}
                {rows > 1 &&
                    Array.from({ length: rows - 1 }).map((_, i) => {
                        const z = (i + 1) * panelDepth;
                        const y = yAtZ(z);

                        return (
                            <mesh
                                key={`mid-beam-${sIndex}-${i}`}
                                position={[0, y, z]}
                                rotation={[-roofTilt, 0, 0]}
                            >
                                <boxGeometry
                                    args={[
                                        w + 0.06,
                                        frameThickness / 2,
                                        frameThickness / 2,
                                    ]}
                                />
                                <meshStandardMaterial color={aluminumColor} />
                            </mesh>
                        );
                    })}

                {/* CAM PANELLER */}
                {Array.from({ length: rows }).map((_, row) =>
                    Array.from({ length: panelCountX }).map((__, col) => {
                        const xCenter = -w / 2 + (col + 0.5) * panelWidth;

                        const zStart = row * panelDepth;
                        const zEnd = (row + 1) * panelDepth;
                        const zCenter = (zStart + zEnd) / 2;

                        const yStart = yAtZ(zStart);
                        const yEnd = yAtZ(zEnd);

                        const yCenter =
                            (yStart + yEnd) / 2 +
                            rafterHeight / 2 +
                            glassThickness / 2 -
                            0.03;

                        const glassLength =
                            Math.sqrt(
                                panelDepth * panelDepth +
                                (yEnd - yStart) * (yEnd - yStart)
                            ) - glassGap;

                        return (
                            <group
                                key={`glass-group-${sIndex}-${row}-${col}`}
                            >
                                <mesh
                                    position={[
                                        xCenter,
                                        yCenter + 0.01,
                                        zCenter + 0.02,
                                    ]}
                                    rotation={[-roofTilt, 0, 0]}
                                >
                                    <boxGeometry
                                        args={[
                                            panelWidth - glassGap,
                                            glassThickness,
                                            glassLength,
                                        ]}
                                    />
                                    <meshPhysicalMaterial
                                        color={glassColor}
                                        transparent
                                        opacity={0.35}
                                        roughness={0}
                                        metalness={0}
                                        reflectivity={0.8}
                                        transmission={0.9}
                                        side={DoubleSide}
                                    />
                                </mesh>

                                {config.isDouble && (
                                    <mesh
                                        position={[
                                            xCenter,
                                            yCenter - 0.005,
                                            zCenter,
                                        ]}
                                        rotation={[-roofTilt, 0, 0]}
                                    >
                                        <boxGeometry
                                            args={[
                                                panelWidth - glassGap,
                                                glassThickness,
                                                glassLength,
                                            ]}
                                        />
                                        <meshPhysicalMaterial
                                            color={glassColor2}
                                            transparent
                                            opacity={0.35}
                                            roughness={0}
                                            metalness={0}
                                            reflectivity={0.8}
                                            transmission={0.9}
                                            side={DoubleSide}
                                        />
                                    </mesh>
                                )}
                            </group>
                        );
                    })
                )}

                {/* Ön dikmeler */}
                {frontFeetPositions.map((x, idx) => (
                    <mesh
                        key={`foot-${sIndex}-${idx}`}
                        position={[x, hFront / 2, 0]}
                    >
                        <boxGeometry args={[postSize, hFront, postSize]} />
                        <meshStandardMaterial color={aluminumColor} />
                    </mesh>
                ))}

                {/* Arka dikmeler */}
                {backFeetPositions.map((x, idx) => (
                    <mesh
                        key={`bfoot-${sIndex}-${idx}`}
                        position={[x, hBack / 2, houseFrontZ]}
                    >
                        <boxGeometry args={[postSize, hBack, postSize]} />
                        <meshStandardMaterial color={aluminumColor} />
                    </mesh>
                ))}

                {/* **SECTION FAYANS ZEMİNİ** */}
                <group>
                    {Array.from({ length: tileCountX }).map((_, ix) =>
                        Array.from({ length: tileCountZ }).map((__, iz) => {
                            const x = -w / 2 + ix * tileW + tileW / 2;
                            const z = iz * tileD - d / 2;

                            return (
                                <mesh
                                    key={`tile-${sIndex}-${ix}-${iz}`}
                                    rotation={[-Math.PI / 2, 0, 0]}
                                    position={[x, 0, z]}
                                >
                                    <planeGeometry
                                        args={[tileW * 0.98, tileD * 0.98]}
                                    />
                                    <meshStandardMaterial
                                        color={
                                            (ix + iz) % 2 === 0
                                                ? "#e8e8e8"
                                                : "#f3f3f3"
                                        }
                                    />
                                </mesh>
                            );
                        })
                    )}
                </group>

                {/* TEK KATLI EV GÖVDESİ (section bazlı) */}
                {globalHFront !== globalHBack && (
                    <mesh
                        position={[0, houseHeight / 2, houseCenterZ]}
                        receiveShadow
                        castShadow
                    >
                        <boxGeometry
                            args={[
                                houseWidth,
                                houseHeight,
                                houseDepth,
                            ]}
                        />
                        <meshStandardMaterial
                            color="#d4d0c8"
                            roughness={0.9}
                            metalness={0.0}
                        />
                    </mesh>
                )}

                {/* Genişlik ölçüsü (mm) - bu section için */}
                <group>
                    <mesh position={[0, 0, -0.1]}>
                        <boxGeometry args={[w, 0.005, 0.005]} />
                        <meshStandardMaterial color="#000000" />
                    </mesh>
                    <mesh
                        position={[-w / 2, 0, -0.1]}
                        rotation={[0, 0, Math.PI / 2]}
                    >
                        <coneGeometry args={[0.015, 0.03, 8]} />
                        <meshStandardMaterial color="#000000" />
                    </mesh>
                    <mesh
                        position={[w / 2, 0, -0.1]}
                        rotation={[0, 0, -Math.PI / 2]}
                    >
                        <coneGeometry args={[0.015, 0.03, 8]} />
                        <meshStandardMaterial color="#000000" />
                    </mesh>
                    <Text
                        position={[0, 0.05, -0.2]}
                        fontSize={0.08}
                        rotation={[0, Math.PI, 0]}
                        color="#000000"
                        anchorX="center"
                        anchorY="middle"
                    >
                        {`${(w * 1000)} mm`}
                    </Text>
                </group>

                {/* İlk section için: yüksekliik ve derinlik ölçüleri */}
                {sIndex === 0 && (
                    <group>
                        {/* Ön yükseklik */}
                        <group>
                            <mesh position={[-w / 2 - 0.1, globalHFront / 2, 0]}>
                                <boxGeometry args={[0.005, globalHFront, 0.005]} />
                                <meshStandardMaterial color="#000000" />
                            </mesh>
                            <mesh
                                position={[-w / 2 - 0.1, 0, 0]}
                                rotation={[0, 0, Math.PI]}
                            >
                                <coneGeometry args={[0.015, 0.03, 8]} />
                                <meshStandardMaterial color="#000000" />
                            </mesh>
                            <mesh
                                position={[-w / 2 - 0.1, globalHFront, 0]}
                            >
                                <coneGeometry args={[0.015, 0.03, 8]} />
                                <meshStandardMaterial color="#000000" />
                            </mesh>
                            <Text
                                position={[-w / 2 - 0.3, globalHFront / 2, 0]}
                                rotation={[0, Math.PI, 0]}
                                fontSize={0.08}
                                color="#000000"
                                anchorX="center"
                                anchorY="middle"
                            >
                                {`${frontHeightMm.toFixed(0)} mm`}
                            </Text>
                        </group>

                        {/* Arka yükseklik */}
                        <group>
                            <mesh position={[-w / 2 - 0.1, globalHBack / 2, d]}>
                                <boxGeometry args={[0.005, globalHBack, 0.005]} />
                                <meshStandardMaterial color="#000000" />
                            </mesh>
                            <mesh
                                position={[-w / 2 - 0.1, 0, d]}
                                rotation={[0, 0, Math.PI]}
                            >
                                <coneGeometry args={[0.015, 0.03, 8]} />
                                <meshStandardMaterial color="#000000" />
                            </mesh>
                            <mesh
                                position={[-w / 2 - 0.1, globalHBack, d]}
                            >
                                <coneGeometry args={[0.015, 0.03, 8]} />
                                <meshStandardMaterial color="#000000" />
                            </mesh>
                            <Text
                                position={[-w / 2 - 0.3, globalHBack / 2, d]}
                                rotation={[0, Math.PI, 0]}
                                fontSize={0.08}
                                color="#000000"
                                anchorX="center"
                                anchorY="middle"
                            >
                                {`${backHeightMm.toFixed(0)} mm`}
                            </Text>
                        </group>

                        {/* Derinlik */}
                        <group>
                            <mesh position={[-w / 2 - 0.2, 0, d / 2]}>
                                <boxGeometry args={[0.005, 0.005, d]} />
                                <meshStandardMaterial color="#000000" />
                            </mesh>
                            <mesh
                                position={[-w / 2 - 0.2, 0, 0]}
                                rotation={[-Math.PI / 2, 0, 0]}
                            >
                                <coneGeometry args={[0.015, 0.03, 8]} />
                                <meshStandardMaterial color="#000000" />
                            </mesh>
                            <mesh
                                position={[-w / 2 - 0.2, 0, d]}
                                rotation={[Math.PI / 2, 0, 0]}
                            >
                                <coneGeometry args={[0.015, 0.03, 8]} />
                                <meshStandardMaterial color="#000000" />
                            </mesh>
                            <Text
                                position={[-w / 2 - 0.3, 0.05, d / 2]}
                                rotation={[0, -Math.PI / 2, 0]}
                                fontSize={0.08}
                                color="#000000"
                                anchorX="center"
                                anchorY="middle"
                            >
                                {`${depthMm.toFixed(0)} mm`}
                            </Text>
                        </group>
                    </group>
                )}
            </group>
        );
posX += dirX * w;
posZ += dirZ * w;

        if (section.left_angle > 0) {
            angleSum += (section.left_angle);

        }

    });


    return (<>{group} </>);
};
